<template>

	<div class="help-dialog" v-if="showDialog">
		<div class="dialog-bg"></div>
		<div class="help-box">
			<h4 class="h4">帮助</h4>

			<div class="content">
				<p>
					1.每日签到固定获得1积分。 <br>
					2.连续签到满2天额外奖励3积分。<br>
					3.连续签到满5天额外奖励7积分。<br>
					4.连续签到满7天额外奖励15积分，且可领取随机任务，完成可随机获得9-999积分。<br>
					5.若当前状态已满足随机任务，则直接获得奖励。<br>
					6.签到满7天触发随机事件，需在当天完成相应任务则可获得积分奖励。<br>
					7.签到7天为一个周期，额外奖励重新计算，但不影响连续签到总天数。<br>
					<!--  8.活动期间内，连续签到满30天及以上用户可进入奖金池，所有进入奖金池的用户瓜分奖金池内的金额，连续签到天数越多，奖励金额越高<br> -->
					8.漏签会中断连续签到任务。<br>
                    9.同一设备、手机号、身份信息注册的不同账户，视为同一账号，不可重复获得签到奖励。<br>
					10.活动期间，凡以不正当手段（如恶意刷单、作弊、扰乱系统、实施网络攻击等）参与本次活动的用户，众安保险有权终止其参与活动并回收所有奖品；如遇不可抗力（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整、活动中存在大面积作弊行为、活动遭遇严重网络攻击或系统故障导致活动不能正常进行）的影响，众安保险可暂停、中止或终止活动。<br />
					11.关于活动任何其它疑问，请咨询全国统一服务热线：1010-9955，举报建议及投诉电话021-80399188。
                    <br>
				</p>
			</div>

			<div class="bgline"></div>

			<div class="cancel-btn">
				<a href="#" @click="cancelDialog"><img src="../../assets/images/sign/btn_close.png" width="100%" alt=""></a>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		props:['showDialog'],
		methods: {
			cancelDialog () {
				this.$emit('cancel', 'help')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/components/Help-dialog.vue